import { SxProps, Theme } from "@mui/material";

export const stylesPage = (theme: Theme) => ({
  container: {
    width: "100%",
    minWidth: "320px",
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  paperCliente: {
    borderRadius: 1,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    padding: "20px",
    minWidth: "320px",
    width: "100%",
    flexDirection: "column",
  },
  browserTabs: {
    width: "100%",
    minHeight: 50,
    "& .MuiTab-root": {
      minHeight: 50,
      height: 50,
      padding: "4px 14px",
      fontSize: "0.85rem",
      lineHeight: 1,
      textTransform: "none",
      borderBottom: "none",
      borderTopLeftRadius: 5,
      borderTopRightRadius: 5,
      marginBottom: "-1px",
    },
  } as SxProps<Theme>,
  boxTab: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  } as SxProps<Theme>,
});
